import axios from 'axios';
import {configApi} from '../../api/configApi';
import {router} from '../../main.js';
import {headers} from '../../api/headers';
import {store} from '../index';

export default {
  namespaced: true,
  state: {
       tipocostos: [],
       tipocosto: null,
       pagination: {
          descending: true,
          page: 1,
          rowsPerPage: 0,
          sortBy: '',
          totalItems: 0,
          rowsPerPageItems: [1, 2, 4, 8, 16],
    },
    pages: 0,
    loading: false,
  },
  getters: {
    listTipocostos: (state,getters,rootState) => {
          return state.tipocostos;
    },
    tipocosto: (state,getters,rootState) => {
        return state.tipocosto;
    },
    pagination(state,getters,rootState){
      return state.pagination;
    },
    pages(state,getters,rootState){
      return state.pages;
    },
    totalItemCount(state,getters,rootState){
        return state.pagination.totalItems;
    },
    loading(state,getters,rootState){
        return state.loading;
    },
  },
  mutations: {
        listTipocostos: (state,tipocostos) => {
          state.tipocostos = tipocostos;
          state.pagination.totalItems = tipocostos.total;
          state.pagination.page = tipocostos.current_page;
          state.pagination.rowsPerPage = tipocostos.per_page;
       },
      listTipocostosSearch: (state,tipocostos) => {
            if(tipocostos != null){ 
                state.tipocostos = tipocostos;
            }else{
              state.tipocostos = null;
            }
       },
      viewTipocosto(state,id){
        let auxTipocosto = state.tipocostos.filter((item) => item.id == id);
        state.tipocosto = auxTipocosto[0];
      },
    pages(state){
         if (state.pagination.rowsPerPage == null ||
              state.pagination.totalItems == null) { 
              state.pages = 0;
          } 

        state.pages = Math.ceil(state.pagination.totalItems / state.pagination.rowsPerPage);
    },
  },
  actions: {
    listTipocostos({state,getters,commit,rootState}){
      state.loading = true;
      axios.get(`${configApi.apiUrl}tipo_costo_all`,null,{headers: headers})
      .then(response => {
        ////console.log(response.data.data.data);
        commit('listTipocostos',response.data.data);
        commit('pages');
        state.loading = false;
      })
      .catch(error => {
        state.loading = false;
        swal("Error!", "Error al obtener los Tipo de costos!", "error");
        console.error(error);
      });

    },
  newTipocosto({state,getters,commit,rootState},payload){
      // descripcion
      store.dispatch('validateToken');
      axios.post(`${configApi.apiUrl}tipocosto`,payload,{headers: headers})
      .then(response => {
        swal("Exito!", "Se creo el Tipo de costo correctamente!", "success");
        store.dispatch('tipocosto/listTipocostos',state.pagination.page);
      })
      .catch(error => {
        swal("Error!", "Error al crear el Tipo de costo!", "error");
        console.error(error);
      });
  },
  updateTipocosto({state,getters,commit,rootState},payload){
      // descripcion
      store.dispatch('validateToken');
      axios.put(`${configApi.apiUrl}tipocosto/${payload.id}`,payload,{headers: headers})
      .then(response => {
        swal("Exito!", "Se actualizo el Tipo de costo correctamente!", "success");
        store.dispatch('tipocosto/listTipocostos',state.pagination.page);
      })
      .catch(error => {
        swal("Error!", "Error al actualizar el tipocosto!", "error");
        console.error(error);
      });
  },
  deleteTipocosto({state,getters,commit,rootState},tipocosto){
    store.dispatch('validateToken');
    axios.delete(`${configApi.apiUrl}tipocosto/${tipocosto}`,null,{headers: headers})
     .then(response => {
        swal("Exito!", "Se elimino el Tipo de costo correctamente!", "success");
        store.dispatch('tipocosto/listTipocostos',state.pagination.page);
     })
     .catch(error => {
        swal("Error!","Error al eliminar el Tipo de costo!","error");
        //console.log(error);
     });
  },
    searchTipocostos({state,getters,commit,rootState},key){
      store.dispatch('validateToken');
      store.commit('changeLoader', true);
      axios.get(`${configApi.apiUrl}buscarTipocosto?descripcion=${key}`,null,{headers: headers})
      .then(response => {
        commit('listTipocostosSearch',response.data.data);
        store.commit('changeLoader', false);
      })
      .catch(error => {
        store.commit('changeLoader', false);
        swal("Error!", "Error al obtener los Tipo de costos!", "error");
        console.error(error);
      });

    },
    searchlistTipocostos({state,getters,commit,rootState},key){
      store.dispatch('validateToken');
      store.commit('changeLoader', true);
      axios.get(`${configApi.apiUrl}buscarTipocosto?nombre=${key}`,null,{headers: headers})
      .then(response => {
        commit('listTipocostosSearch',response.data.data);
        store.commit('changeLoader', false);
      })
      .catch(error => {
        store.commit('changeLoader', false);
        swal("Error!", "Error al obtener los Tipo de costos!", "error");
        console.error(error);
      });

    },
  },
}